import { qryWxParam } from '../../api';
import { wxApi } from '@tencent/ppd-base-libs';
import JsApi from '../../jsapi';

let jsApiInitFlag = false; // jsapi初始化标记

export async function scanPay(srcUrl: string) {
  if (jsApiInitFlag) {
    await doScan();
  } else {
    await initJsApi(srcUrl, async () => {
      await doScan();
    });
  }
}
async function initJsApi(srcUrl: string, cb = () => { /* do nothing */ }) {
  const result = await qryWxParam(srcUrl);

  const conf = {
    ...result,
    jsApiList: ['scanQRCode'],
  };

  wxApi.checkWxSDKReady(async () => {
    await JsApi.init(conf);
    jsApiInitFlag = true;
    console.log('config ok');
    if (typeof cb === 'function') {
      cb();
    }
  });
}

async function doScan() {
  await JsApi.scanQRCode({
    needResult: 0, // 0结果由微信处理，1直接返回扫描结果
    scanType: ['qrCode'],
  });
}

